<template>
  <BContainer
    v-if="currentUser"
    class="mb-4"
  >
    <div class="d-flex justify-content-end">
      <BBreadcrumb
        v-if="$route.meta.breadcrumb"
        :items="$route.meta.breadcrumb || []"
      />
    </div>

    <BRow
      class="py-2 py-md-0"
    >
      <!-- AGENT PROFILE PICTURE -->
      <BCol
        cols="12"
      >
        <AccountProfilePictures
          :loading="state.busy"
          :user="currentUser"
        />
      </BCol>

      <!-- AGENT INFORMATIONS -->
      <BCol
        cols="12"
      >
        <BOverlay
          :show="state.busy"
          opacity="0.5"
        >
          <BCard
            class="border mt-2 m min-h-450px"
          >
            <BCardText>
              <BTabs
                v-model="currentTabIndex"
                active-nav-item-class="text-primary"
                nav-class="scrollable-x-tabs no-scrollbar nav-representative-tabs gap-x-1"
                pills
              >
                <template #tabs-start>
                  <div class="nav-item">
                    <div
                      class="d-flex align-items-center position-absolute"
                      style="padding: 2px 1px; height: 38px;"
                    >
                      <i
                        class="fas fa-chevron-left bg-primary-light p-1 rounded-lg"
                        style="font-size: 20px;"
                      />
                    </div>
                  </div>
                </template>
                <template #tabs-end>
                  <div class="nav-item">
                    <div
                      class="d-flex align-items-center position-absolute"
                      style="right: 20px; padding: 2px 1px; height: 38px;"
                    >
                      <i
                        class="fas fa-chevron-right bg-primary-light p-1 rounded-lg"
                        style="font-size: 20px;"
                      />
                    </div>
                  </div>
                </template>
                <BTab>
                  <template #title>
                    <i :class="iconState('fa-file-user', currentTabIndex === 0)" /> Info
                  </template>

                  <BContainer
                    class="h-100 p-0"
                    fluid
                  >
                    <AccountInformations
                      ref="representativeInformations"
                      :user="currentUser"
                    />
                  </BContainer>
                </BTab>
                <BTab lazy>
                  <template #title>
                    <i :class="iconState('fa-key', currentTabIndex === 1)" />Change Password
                  </template>

                  <BContainer
                    class="h-100 p-0"
                    fluid
                  >
                    <AccountChangePassword />
                  </BContainer>
                </BTab>
              </BTabs>
            </BCardText>
          </BCard>
        </BOverlay>
      </BCol>
    </BRow>
  </BContainer>
</template>
<script>
import { mapGetters } from 'vuex'

import AccountProfilePictures from '@/views/shared/account-settings/ProfilePictures.vue'
import AccountInformations from '@/views/shared/account-settings/Informations.vue'
import AccountChangePassword from '@/views/shared/account-settings/ChangePassword.vue'

import MxMisc from '@/mixins/misc'
import MxFormatter from '@/mixins/formatter'

export default {
  name: 'VSharedAccountSettings',

  components: {
    AccountProfilePictures,
    AccountInformations,
    AccountChangePassword
  },

  mixins: [
    MxMisc,
    MxFormatter
  ],

  middleware: [
    'auth'
  ],

  metaInfo: () => ({
    title: 'Account Settings'
  }),

  data () {
    return {
      state: {
        busy: false
      },
      currentTabIndex: 0
    }
  },

  computed: {
    ...mapGetters({
      currentUser: 'auth/user'
    })
  },

  mounted () {
    if (this.currentUser) {
      this.$nextTick(() => {
        this.attachArrowScroller('.nav-representative-tabs')
      })
    }
  },
  destroyed () {
    this.detachArrowScroller('.nav-representative-tabs')
  }
}
</script>
